import { defineAction, number, object } from '~/prix'
import { z } from 'zod'
import llmChatGetAction from './llmChatGet.action.json' with { type: 'json' }

const llmChatGetDefinition = defineAction({
  ...llmChatGetAction,

  // input: z.object({
  //   id: z.number(),
  // }),
  // output: z.object({
  //   title: z.string(),
  //   isFixed: z.boolean(),
  //   archivedAt: dateOrIsoString().nullable(),
  //   messages: z.array(
  //     z.object({
  //       id: z.string(),
  //       content: z.string(),
  //       role: z.enum(['user', 'assistant', 'system', 'data']),
  //       modelKey: z.string(),
  //       tokenCount: z.number().nullable(),
  //       costUsd: z.number().nullable(),
  //       createdAt: z.date(),
  //       toolCalls: z
  //         .array(
  //           z.object({
  //             id: z.string(),
  //             toolName: z.string(),
  //             callArguments: z.any().nullable(),
  //             callResponse: z.any().nullable(),
  //             latencyMs: z.number().nullable(),
  //             createdAt: z.date(),
  //           }),
  //         )
  //         .optional(),
  //     }),
  //   ),
  // }),
  input: object({
    id: number(),
  }),
  output: object<any>({}),
})

export default llmChatGetDefinition
